import {DEFAULT_LANG, SECOND_LANG} from "~/constants/values/default_values";
import type {Coordinates} from "~/types/addressTypes";
import {GEOCODE_API} from "~/constants/api/base";

type OptionsAddress = {
    street: string,
    city?: string,
    lang?: typeof DEFAULT_LANG | typeof SECOND_LANG
}
type OptionsCoordinates = {
    coords: Coordinates,
    lang?: typeof DEFAULT_LANG | typeof SECOND_LANG
}
export async function getSuggestionByAddress(opt: OptionsAddress) {
    const { locale } = useNuxtApp().$i18n

    if (!opt.city) {
        opt.city = useStoreUserCity().value.title
    }
    if (!opt.lang) {
        opt.lang = locale.value
    }

    const geocoderLang = opt.lang === SECOND_LANG ? 'kk_KZ' : 'ru_RU'

    try {
        // const response = await $fetch(`${GEOCODE_API}/suggest?text=${opt.city}, ${opt.street}`)
        const {data: response, error} = await useApi(`${GEOCODE_API}/suggest?text=${opt.city}, ${opt.street}&lang=${geocoderLang}`, 'GET')
        if (response.value?.results) {
            return response.value
        }
        if (error.value) {
            return error.value.message
        }
    } catch (e) {
        console.log(e)
    }
}
export async function getCoordsByAddress(opt: OptionsAddress) {
    const { locale } = useNuxtApp().$i18n

    if (!opt.city) {
        opt.city = useStoreUserCity().value.title
    }
    if (!opt.lang) {
        opt.lang = locale.value
    }

    const geocoderLang = opt.lang === SECOND_LANG ? 'kk_KZ' : 'ru_RU'

    try {
        // const response = await $fetch(`${GEOCODE_API}/forward?q=${opt.city}, ${opt.street}`)
        const {data: response, error} = await useApi(`${GEOCODE_API}/forward?q=${opt.city}, ${opt.street}&lang=${geocoderLang}`, 'GET')
        if (response.value?.lat && response.value?.lon) {
            return {coords: {lat: response.value?.lat, lon: response.value?.lon}, err: '', address: {street: response.value?.address, house: response.value?.houseNumber}}
        }
        if (error.value) {
            return { coords: {lat: null, lon: null}, err: error.value.message, address: null }
        }
    } catch (e) {
        console.log(e)
    }
}

export async function getAddressByCoords(opt: OptionsCoordinates) {
    const { locale } = useNuxtApp().$i18n

    if (!opt.lang) {
        opt.lang = locale.value
    }

    const geocoderLang = opt.lang === SECOND_LANG ? 'kk_KZ' : 'ru_RU'

    try {
        // const response = await $fetch(`${GEOCODE_API}/reverse?lat=${opt.coords.lat}&lon=${opt.coords.lon}`)
        const {data: response, error} = await useApi(`${GEOCODE_API}/reverse?lat=${opt.coords.lat}&lon=${opt.coords.lon}&lang=${geocoderLang}`, 'GET')
        if (response.value) {
            const addressData = {}
            addressData.street = response.value?.address
            addressData.house = response.value?.houseNumber
            return addressData
        }
        if (error.value) {
            return { coords: {lat: null, lon: null}, err: error.value.message }
        }
    } catch (e) {
        console.log(e)
    }
}